module.exports = __webpack_public_path__ + "static/media/gifts@1x.de86c1e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doodles/gifts@1x.png
// module id = 2504
// module chunks = 70